// Session security epoch — client copy (Token & Session Revocation Policy,
// Phase B, 2026-10-06). Same semantics as functions/sessionEpoch.js,
// firestore.rules and storage.rules; all four are pinned to the shared vectors
// in functions/test/fixtures/sessionEpochVectors.json.
//
// users/{uid}.sessionsValidAfter: integer Unix SECONDS, server-written only.
//   absent → VALID; not a safe integer ≥ 0 → MALFORMED;
//   token auth_time (seconds) ≥ epoch → VALID; otherwise STALE.
export const EPOCH_FIELD = 'sessionsValidAfter';
export const EPOCH_STATUS = Object.freeze({ VALID: 'VALID', STALE: 'STALE', MALFORMED: 'MALFORMED' });

export const hasSessionEpoch = (profile) => !!profile && typeof profile === 'object' && Object.prototype.hasOwnProperty.call(profile, EPOCH_FIELD);

export function sessionEpochStatus(profile, authTimeSec) {
  if (!hasSessionEpoch(profile)) return EPOCH_STATUS.VALID;
  const epoch = profile[EPOCH_FIELD];
  if (!(Number.isSafeInteger(epoch) && epoch >= 0)) return EPOCH_STATUS.MALFORMED;
  if (!Number.isSafeInteger(authTimeSec)) return EPOCH_STATUS.STALE;
  return authTimeSec >= epoch ? EPOCH_STATUS.VALID : EPOCH_STATUS.STALE;
}

// Firebase ID-token claims → auth_time in whole seconds (or null).
export const authTimeFromClaims = (claims) => {
  const t = claims && claims.auth_time;
  const n = typeof t === 'number' ? t : (typeof t === 'string' && /^\d+$/.test(t) ? Number(t) : NaN);
  return Number.isSafeInteger(n) ? n : null;
};
